import React from "react";

import { useHistory } from "react-router-dom";
import { ConfirmationContainer, ConfirmationIcon, ConfirmationText } from "./styles";
import { SignInButton } from "~/pages/Auth/SingIn/styles";
import { useDispatch } from "react-redux";

function Confirmation() {
  const dispatch = useDispatch();
  const history = useHistory();

  return (
    <ConfirmationContainer>
      <ConfirmationIcon className="fa fa-check-circle-o" />
      <ConfirmationText className="mt-4">
        <p>Sua senha foi definida com sucesso!</p>
      </ConfirmationText>

      <SignInButton type="submit" className="mt-3" onClick={() => {
        dispatch({ type: "STEP_EMPLOYEE", step: 1 });
        history.push("/");
      }}>
        <span>Acessar</span>
      </SignInButton>
    </ConfirmationContainer>
  );
}

export default Confirmation;
